import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ServicoVozRegistro {
  private vozPtBr?: SpeechSynthesisVoice;
  private audioPreparado = false;

  iniciar() {
    this.carregarVozes();
    if ('speechSynthesis' in window) {
      window.speechSynthesis.onvoiceschanged = () => this.carregarVozes();
    }
  }

  falar(texto: string, usarAtrasoMobile = false) {
    if (!('speechSynthesis' in window)) {
      return;
    }

    const sintetizador = window.speechSynthesis;
    this.carregarVozes();
    if (sintetizador.paused) {
      sintetizador.resume();
    }
    if (sintetizador.speaking) {
      sintetizador.cancel();
    }

    const fala = new SpeechSynthesisUtterance(texto);
    fala.lang = 'pt-BR';
    fala.rate = 0.95;
    fala.pitch = 1;
    if (this.vozPtBr) {
      fala.voice = this.vozPtBr;
    }

    window.setTimeout(() => {
      sintetizador.speak(fala);
      if (sintetizador.paused) {
        sintetizador.resume();
      }
    }, usarAtrasoMobile ? 80 : 0);
  }

  prepararAudio() {
    if (!('speechSynthesis' in window) || this.audioPreparado) {
      return;
    }

    const sintetizador = window.speechSynthesis;
    this.carregarVozes();
    const fala = new SpeechSynthesisUtterance(' ');
    fala.lang = 'pt-BR';
    fala.volume = 0;
    if (this.vozPtBr) {
      fala.voice = this.vozPtBr;
    }
    sintetizador.speak(fala);
    if (sintetizador.paused) {
      sintetizador.resume();
    }
    this.audioPreparado = true;
  }

  private carregarVozes() {
    if (!('speechSynthesis' in window)) {
      return;
    }

    const vozes = window.speechSynthesis.getVoices();
    this.vozPtBr = vozes.find(voz => voz.lang?.toLowerCase() === 'pt-br')
      || vozes.find(voz => voz.lang?.toLowerCase().startsWith('pt'))
      || this.vozPtBr;
  }
}
